/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")


  
    
export interface API54188Item {
  
  /**  */
  id?: number;
  
  /** 评论内容 */
  content?: string;
  
  /** 创建人发起人 */
  creator?: string;
  
  /** 创建时间 */
  createdAt?: any;
  
  /** 创建人发起人logo */
  creatorLogo?: string;
  
  /** 创建人发起人名称 */
  creatorName?: string;
  
  /** 创建人发起人状态 */
  creatorStatus?: string;
  
  /** 是否可删除 */
  canDelete?: number;
  
};
    
  



export interface API54188Req {
  
  /** 任务ID(Long) */
  taskId?: string;
    
};



export interface API54188Res {
  /** T  */
  list?: API54188Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 54188 任务评论列表

export interface IUseGetAPI54188Return {
  /** 任务评论列表: 接口请求状态 */
  isAPI54188Loading: boolean;
  /** 任务评论列表: 接口请求返回数据 */
  dataAPI54188: API54188Res;
  /**  任务评论列表: 接口数据请求方法 */
  fetchAPI54188Data:  (inputs: API54188Req, config?: YWRequestConfig) => Promise<API54188Res>;
  /** 任务评论列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI54188 = ():IUseGetAPI54188Return => {
  let isMount = true;
  const [isAPI54188Loading, setIsAPI54188Loading] = useState(false);
  const [dataAPI54188, setDataAPI54188] = useState<API54188Res>({} as API54188Res);
  const requestUrl = `${basePath}/team-work/workTask/comment/listComment`;

  const fetchAPI54188Data = async (inputs: API54188Req, config?: YWRequestConfig): Promise<API54188Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API54188Req>) || {}) as API54188Req;
    
  
    if ( isMount ) {
      setIsAPI54188Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API54188Res>(`${basePath}/team-work/workTask/comment/listComment?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI54188(res || {} as API54188Res);
        setIsAPI54188Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI54188Loading(false);
      }
      return false as unknown as API54188Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI54188Loading,
    dataAPI54188,
    fetchAPI54188Data,
    requestUrl,
  }
}

